export enum RateCategoryEnum {
  WEIGHT = "WEIGHT",
  ULD = "ULD",
}
